import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  constructor(
    private _auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
  ) { }

  loginForm: FormGroup;
  submitted: boolean = false;
  errorApi: boolean = false;
  errorMessage:string=''

  ngOnInit(): void {

    if (this._auth.isAuthenticatedUser()) {
      this.location.back()
    }

    this.loginForm = this.fb.group({
      user_name: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });

  }
 
  onLogin() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this._auth.logIn(this.loginForm.getRawValue()).subscribe((resp:any)=>{
      if (resp.success) {
        localStorage.setItem('authToken', resp.token);
        localStorage.setItem('authTokenExpiration', resp.expiresIn);
        localStorage.setItem('trackId', resp.trackId);
        localStorage.setItem('user', JSON.stringify(resp.user));
        this.router.navigate(['/activity'])
      }else{
        this.errorMessage=resp.message
        this.errorApi=true;
      }
      },(err)=>{
        this.errorMessage=err.error.message
        this.errorApi=true;        
      })
    }
  }

}
